














import { defineComponent, onMounted } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";

export default defineComponent({
  name: "ConfirmCodeView",
  components: { BaseIcon },
  props: {
    loading: { type: Boolean, required: true },
    success: { type: Boolean, default: false },
  },
  emits: ["success", "error"],
  setup(props, { emit }) {
    onMounted(() => {
      setTimeout(() => {
        emit(props.success ? "success" : "error");
      }, 2000);
    });
  },
});
